import React from 'react';
import './OperationCard.css';

const ProfitCard = ({ profit }) => {
  // Функция для форматирования суммы
  const formatAmount = (amount) => {
    const formattedAmount = new Intl.NumberFormat('ru-RU', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
    
    return `+${formattedAmount} RUB`;
  };

  // Функция для правильного склонения слова "рубль"
  const getRubleWord = (amount) => {
    const num = Math.abs(amount);
    const lastDigit = num % 10;
    const lastTwoDigits = num % 100;
    
    if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
      return 'рублей';
    }
    if (lastDigit === 1) {
      return 'рубль';
    }
    if (lastDigit >= 2 && lastDigit <= 4) {
      return 'рубля';
    }
    return 'рублей';
  };

  // Формируем данные для отображения
  const fromDate = profit.from_date || '';
  const toDate = profit.to_date || '';
  const amount = profit.amount || 0;
  const percentage = profit.percentage || 0;
  
  // Форматируем сумму для отображения
  const formattedAmount = new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
  
  const rubleWord = getRubleWord(amount);
  const descriptionPrefix = `Прибыль с ${fromDate} по ${toDate} года: `;
  const descriptionAmount = `${formattedAmount} ${rubleWord} (${percentage}%)`;

  return (
    <a 
      href="#" 
      data-fls-block="" 
      data-fls-number="" 
      className="body-history__count count count--hover"
    >
      <div className="count__main count__main--condition-income count__main--icon-condition">
        <div className="count__content">
          <h5 className="count__title count__title--title-20">
            счет {profit.account_number}
          </h5>
          <div className="count__name">
            <span className="count__name-text">
              {descriptionPrefix}
              <span style={{ color: '#228b22' }}>{descriptionAmount}</span>
            </span>
          </div>
        </div>
      </div>
      <div className="count__result count__result--income">
        <span>{formatAmount(profit.amount)}</span>
      </div>
    </a>
  );
};

export default ProfitCard;

